import { createTimeline } from 'animejs';

export default function Filter_Animation(animation_el) {
	const input_el = animation_el.querySelector(`input[type="text"]`);
	const cursor_el = animation_el.querySelector(`.cursor`);

	if (!input_el || !cursor_el) {
		return;
	}

	const checkbox_els = animation_el.querySelectorAll(`input[type="checkbox"]`);

	const text = input_el.dataset.text;

	const tl = createTimeline({
		autoplay: false,
		loop: true,
		loopDelay: 1800,
	});

	// Step 1: Move cursor to input position
	const cursor_left = 40;

	tl.add(cursor_el, {
		left: cursor_left,
		top: input_el.offsetTop + input_el.offsetHeight / 2,
		duration: 500,
		opacity: 1,
	});

	// Step 2: Type out text character by character
	for (let i = 1; i <= text.length; i++) {
		const part = text.substring(0, i);

		tl.add(cursor_el, {
			left: cursor_left + part.length * 8,
			top: input_el.offsetTop + input_el.offsetHeight / 2,
			duration: 0,
		});

		tl.add(input_el, {
			value: part,
			duration: 100,
		});
	}

	// Step 3: Move cursor to each checkbox and check them
	const animation_rect = animation_el.getBoundingClientRect();
	for (const checkbox_el of checkbox_els) {
		const rect = checkbox_el.getBoundingClientRect();

		tl.add(cursor_el, {
			left: rect.left - animation_rect.left,
			top: rect.top - animation_rect.top,
			duration: 800,
		});

		tl.add(checkbox_el, {
			checked: true,
			duration: 200,
		});
	}

	return {
		play: () => {
			tl.play();
		},
		pause: () => {
			tl.pause();
		},
	};
}
